import '../../styles/textStyle.css';
import '../hooks/useAutofillEvent.css';
import './BaseInput.css';
import './BaseInputContent.css';
export var content = '_89buf10-2-0-1 _3xlztp0-2-0-1 _3xlztp2-2-0-1 _3xlztp3-2-0-1 _3xlztpb-2-0-1';